import { queryOptions, useQuery } from "@tanstack/react-query";

import {
  getGetPublishableKeyQueryKey,
  getPublishableKey,
} from "@/api/orval/payment-methods/payment-methods";
import Services from "services/Services";
import { useIsAnonymousCheckout } from "@/modules/anonymousBrowsing/anonymousBrowsingState";

export function useStripePublishableKey(): string | null {
  const anonymousCheckout = useIsAnonymousCheckout();
  const { data } = useQuery(
    queryOptions({
      queryKey: [...getGetPublishableKeyQueryKey(), anonymousCheckout],
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      queryFn: async () => {
        const authToken = await Services.auth.getToken();

        if (!authToken && !anonymousCheckout) {
          return null;
        }

        return (await getPublishableKey()).result;
      },
      retry: 3,
      retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 10000),
    }),
  );

  return data ?? null;
}
